import { routerStyxie } from '@/router/styxieBridge'

Styxie.Initializers.JensenAbout = routerStyxie({ actions: ['show']})
